import React from 'react';
import d3 from 'd3';
import d3Wrap from 'react-d3-wrap';
import { connect } from 'react-redux'
import {demandValidate} from './../../validation/demandValid';

/**
 Used to draw the node shapes for different types of
 network nodes. Also adds class attributes for styling
 including layer information.
 @method nodeShape
 @param d Node information object.
 */
function nodeShape(d) {
    var r = 15;
    var layer = "";
    if ('layer' in d) {
        layer = " " + d['layer'];
    }
    var type = "switch";
    if (d.type !== undefined) {
        type = d.type;
    }
    switch (type) {
        case "switch":
            d3.select(this).append("circle").classed("node_shape switch" + layer, true)
                .attr("r", r);
            break;
        case "host":
            d3.select(this).append("rect").classed("node_shape host" + layer, true).attr("width", 30)
                .attr("height", 30).attr("x", -15).attr("y", -15);
            break;
        case "data_center":
            d3.select(this).append("rect").classed("node_shape data_center" + layer, true).attr("width", 30)
                .attr("height", 30).attr("x", -15).attr("y", -15);
            break;
        case "user_region":
            d3.select(this).append("ellipse").classed("node_shape user_region" + layer, true).attr("rx", 30)
                .attr("ry", 15);
            break;
        default:
            d3.select(this).append("circle").attr("class", "node_shape unknown").attr("r", r);
    }
}

export const NET_ACTION = {
    NONE: "None",
    NEW: "New",
    SHOW_DEMANDS: "ShowDemands",
    SHOW_CAPACITY: "ShowCapacity",
    MODE_CHANGE: "ModeChange",
    NET_CHANGE: "NetChange",
    NODE_SELECT: "NodeSelect",
    LINK_SELECT: "LinkSelect",
    NODE_LINK_SELECT: "NodeLinkSelect",
    NET_RESIZE: "Net_Resize"

};
// Try some network drawing
export const NetDraw = d3Wrap({
    propTypes: {
        net: React.PropTypes.object.isRequired,
        netVisInteract: React.PropTypes.object.isRequired,
        demands: React.PropTypes.object,
        netAction: React.PropTypes.object,
        linkClick: React.PropTypes.func,
        nodeClick: React.PropTypes.func,
        panelClick: React.PropTypes.func,
        linkDblClick: React.PropTypes.func,
        nodeDblClick: React.PropTypes.func

    },
    getInitialState() {
        return {width: null, height: null};
    },

    initialize (svg, data, options) {
        // We keep track of size to see if we really need to re-scale.
        this.oldWidth = this.props.width;
        this.oldHeight = this.props.height;
    },

    oldWidth: null,
    oldHeight: null,

    update(svg, data, options) {
        let that = this;
        let net = this.props.net;
        let action = this.props.netAction;
        let demands = this.props.demands.demandList.filter(d => demandValidate(d, net));
        let netVisInteract = this.props.netVisInteract;
        // console.log("NetDraw update called, action: " + action.type);
        // console.log("netdraw size width:" + this.props.width + " height: " + this.props.height);
        // console.log("old size width: " + this.oldWidth + " height: " + this.oldHeight);
        let clickFuncs = {
            nodeClick: genNodeClick.bind(this),
            linkClick: this.props.linkClick,
            panelClick: genPanelClick.bind(this),
            nodeDblClick: genNodeDblClick.bind(this),
            linkDblClick: genLinkDblClick.bind(this)
        };

        switch (action.type) {
            case NET_ACTION.NEW:
                drawNet(svg, net, demands, netVisInteract, clickFuncs, true);
                scaleAndCenter(svg);
                break;
            case NET_ACTION.NET_CHANGE:
            case NET_ACTION.MODE_CHANGE:
                drawNet(svg, net, demands, netVisInteract, clickFuncs, false);
                nodeHighlighter(svg, netVisInteract);
                linkHighlighter(svg, netVisInteract);
                break;
            case NET_ACTION.NONE:
                // Yup we don't do anything yet.
                break;
            case NET_ACTION.SHOW_CAPACITY:
                vizCapacity(svg, net, netVisInteract);
                break;
            case NET_ACTION.LINK_SELECT:
                linkHighlighter(svg, netVisInteract);
                break;
            case NET_ACTION.NODE_SELECT:
                nodeHighlighter(svg, netVisInteract);
                break;
            case NET_ACTION.NODE_LINK_SELECT:
                linkHighlighter(svg, netVisInteract);
                nodeHighlighter(svg, netVisInteract);
                break;
            case NET_ACTION.NET_RESIZE:
                if (this.props.width !== this.oldWidth || this.props.height !== this.oldHeight) {
                    scaleAndCenter(svg);
                }
                break;
            case NET_ACTION.SHOW_DEMANDS:
                vizDemands(svg, netVisInteract);
                break;
        }
        this.oldWidth = this.props.width;
        this.oldHeight = this.props.height;
    }
}
);

function drawNet(svg, net, demands, netVisInteract, clickFuncs, newNet) {
        let self = this;

        let netNodes = net.nodes,
            netLinks = net.links,
            nodeLinkMap = [], // Used to enable the dragging of nodes with links
            nodeDemandMap = [], // Use to enable the dragging of nodes with demands
            strNodeIndex = {}, // goes from string node id to nodes position in node array. Used with dragmove; Could be set outside
            netGroup; // Used to hold drawing for easy pan/zoom

        let netSVG = d3.select(svg);
        switch (netVisInteract.mouseMode) {
            case "view":
                netSVG.style('cursor', 'default');
                break;
            case "edit":
                netSVG.style('cursor', 'crosshair');
                break;
            default:
                netSVG.style('cursor', 'default');
        }
        if (newNet) {
            netSVG.selectAll("*").remove();
            netGroup = netSVG.append("svg:g");
            // Set up click listener, pan and zoom. Note that we listen for
            // pan & zoom events on the netSVG and then transform the *netGroup*!
            netSVG.on('click', function(){
                    let curCoords = d3.mouse(netGroup[0][0]);
                    clickFuncs.panelClick({x: curCoords[0], y: curCoords[1]});
                    }).call(d3.behavior.zoom()
                        .on('zoom', function(){
                            netGroup.attr('transform', "translate(" + d3.event.translate + ")" + " scale(" + d3.event.scale + ")");
                    })
                        .scaleExtent([0.1, 10.0]))
                .on("mousedown", function () {
                        d3.event.stopPropagation();
                    })
                .on("dblclick.zoom", null);

        } else {
            netGroup = netSVG.select("g");
        }

        let i;
        // Set up the node string to index map
        for (i = 0; i < netNodes.length; i++) {
            strNodeIndex[netNodes[i].id] = i;
        }
        for (i = 0; i < netNodes.length; i++) {
            nodeLinkMap.push({
                "start": [],
                "end": []
            });
            nodeDemandMap.push({
                "start": [],
                "end": []
            });
        }

        // Draw the links in first, then the demands, and then the nodes on top of them.
        // link class attribute includes information on layer or adaptation.

        let linkKey = function (d) {
            return d.source + "-" + d.target;
        };
        let allLinks = netGroup.selectAll("line.netLink").data(netLinks, linkKey);
        allLinks.exit().remove();
        // Add a line element for each new link, put them before the first network node if any
        allLinks.enter().insert("line", "g.netNode");
        // Adjust classes and attributes
        let linkWidth = 3; // TODO: bring in as a property
        allLinks.attr("class", function (d) {
                let cstring = 'netLink';
                let srcNode = netNodes[strNodeIndex[d.source]];
                let dstNode = netNodes[strNodeIndex[d.target]];
                let layer = srcNode.layer === dstNode.layer ? srcNode.layer : "adaptation";
                if (layer) {
                    cstring += ' ' + layer;
                }
                return cstring;
            }
        ).attr("x1", function (d) {
            return netNodes[strNodeIndex[d.source]].x;
        }).attr("y1", function (d) {
            return netNodes[strNodeIndex[d.source]].y;
        }).attr("x2", function (d) {
            return netNodes[strNodeIndex[d.target]].x;
        }).attr("y2", function (d) {
            return netNodes[strNodeIndex[d.target]].y;
        }).style("stroke-width", linkWidth)
            .on('click', function(d){
                    d3.event.stopPropagation();
                    clickFuncs.linkClick(d);})
            .style('cursor', 'pointer')
            .on('dblclick', function(d){
                d3.event.stopPropagation();
                clickFuncs.linkDblClick(d);});
        // Populate the map of nodes to links objects
        allLinks.each(function (d) {
            nodeLinkMap[strNodeIndex[d.source]].start.push(this);
            nodeLinkMap[strNodeIndex[d.target]].end.push(this);
        });

        // Draw in the demands if any
        var demandKey = function (d) {
            return d.source + "-" + d.target;
        };
        var allDemands = netGroup.selectAll("line.netDemand").data(demands, demandKey);
        allDemands.exit().remove();
        // Add a line element for each new link, put them before the first network node if any
        allDemands.enter().insert("line", "g.netNode");
        // Adjust classes and attributes
        let demandWidth = netVisInteract.demandWidth,
            showDemand =  netVisInteract.showDemands;
        allDemands.classed({'netDemand': true, 'hidden': !showDemand})
            .attr("x1", function (d) {
            return netNodes[strNodeIndex[d.source]].x;
        }).attr("y1", function (d) {
            return netNodes[strNodeIndex[d.source]].y;
        }).attr("x2", function (d) {
            return netNodes[strNodeIndex[d.target]].x;
        }).attr("y2", function (d) {
            return netNodes[strNodeIndex[d.target]].y;
        }).style("stroke-width", demandWidth);
        // Populate the map of nodes to links objects
        allDemands.each(function (d) {
            nodeDemandMap[strNodeIndex[d.source]].start.push(this);
            nodeDemandMap[strNodeIndex[d.target]].end.push(this);
        });

        let nodeKey = function (d) {
            return d.id + d.layer + d.type;
        };

        let nodeGroups = netGroup.selectAll("g.netNode").data(netNodes, nodeKey);

        nodeGroups.exit().remove();
        nodeGroups.enter()
            .append("g").attr("class", "netNode")
            .attr("transform", function (d) {
                var x = d.x;
                var y = d.y;
                return "translate(" + x + "," + y + ")";
            })
            .on("mousedown", function () {
                d3.event.stopPropagation(); // Trying to stop the event propagation...
            })
            .on('click', function(d){
                        d3.event.stopPropagation();
                        clickFuncs.nodeClick(d);
            })
            .on('dblclick', function(d){
                d3.event.stopPropagation();
                clickFuncs.nodeDblClick(d);
                // console.log("You Doubleclick node: " + d.id);
                // console.log(d3.event);
             })
            .style('cursor', 'pointer')
            .each(nodeShape)
            .append("text").attr("class", "node_label").attr("dy", ".35em") // vertical-align: middle
            .attr("text-anchor", "middle") // text-align: right
            .text(function (d) {
                return d.id;
            });

        // To make sure nodes are still draggable on any addition or removal of links we
        // update the drag functionality on all nodes.
        var drag = d3.behavior.drag().on("drag", dragMove); //.on("dragend", dragEnd);
        if (netVisInteract.mouseMode === 'edit') {
            nodeGroups.call(drag);
        } else {
            nodeGroups.on('.drag', null);
        }
        /**
         * Helper function used to drag graph nodes along with their connected links
         * @method dragmove
         */
        function dragMove() {
            d3.select(this).attr("transform", function (d) {
                var y = d3.event.y;
                var x = d3.event.x;
                d.x = x;
                d.y = y; // Update data
                // Trying to see how we can track position updates
                var nindex = netNodes.findIndex(function(n){return n.id === d.id;});
                // console.log("You are trying to drag node: " + netNodes[nindex].id);
                var i2 = strNodeIndex[d.id];
                let j;
                // Update all links starting or ending on the node
                for (j = 0; j < nodeLinkMap[i2].start.length; j++) {
                    d3.select(nodeLinkMap[i2].start[j]).attr("x1", x).attr("y1", y);
                }
                for (j = 0; j < nodeLinkMap[i2].end.length; j++) {
                    d3.select(nodeLinkMap[i2].end[j]).attr("x2", x).attr("y2", y);
                }
                // Update all demands starting or ending on the node
                for (j = 0; j < nodeDemandMap[i2].start.length; j++) {
                    d3.select(nodeDemandMap[i2].start[j]).attr("x1", x).attr("y1", y);
                }
                for (j = 0; j < nodeDemandMap[i2].end.length; j++) {
                    d3.select(nodeDemandMap[i2].end[j]).attr("x2", x).attr("y2", y);
                }
                return "translate(" + x + "," + y + ")";
            });
        }

        // function dragEnd() {
        //     var data = d3.select(this).datum();
        //     console.log("drag end called on " + data.id + "new position: " +
        //                "(" + data.x.toString() + ", " + data.y.toString() + ")");
        // }
        vizCapacity(svg, net, netVisInteract);
    }

function scaleAndCenter(svg) {
    // console.log("Scale and center called");
    let svgBounds = svg.getBoundingClientRect();
    let width = svgBounds.width;
    let height = svgBounds.height;
    let avgSize = 30;
    // let svgMatrix = svg.getScreenCTM();
    // console.log(svgBounds);
    // console.log(svgMatrix);
    let netSVG = d3.select(svg);
    let netGroup = netSVG.select("g");
    // Get all the nodes and their coordinates
    let nodeGroups = netGroup.selectAll("g.netNode");
    if (nodeGroups[0].length === 0) {  // In case network is empty
        return;
    }
    let minX = Infinity, maxX = 0, minY = Infinity, maxY = 0;
    nodeGroups.each(function(d, i) {
        // May want to just get these values from the network nodes directly
        let myx = this.transform.baseVal.getItem(0).matrix.e;
        let myy = this.transform.baseVal.getItem(0).matrix.f;
        minX = Math.min(minX, myx);
        maxX = Math.max(maxX, myx);
        minY = Math.min(minY, myy);
        maxY = Math.max(maxY, myy);
    });
    //console.log("Min x: " + minX + " max x: " + maxX + " min y: " + minY + " max y: " + maxY);
    let xrange = maxX - minX + 2*avgSize;
    let yrange = maxY - minY + 2*avgSize;
    let scale = Math.min(width/xrange, height/yrange);
    let xoff = -scale*minX + avgSize/2 + Math.max(0, (width - scale*xrange)/2);
    let yoff = -scale*minY + avgSize/2 + Math.max(0, (height -scale*yrange)/2);
    netGroup.attr('transform', "translate("+xoff + "," + yoff + ")" + " scale(" + scale + ")");
}

function vizCapacity(svg, net, netVisInteract) {
    let netGroup = d3.select(svg).select("g");
    if (netVisInteract.capVis.showCap) {
        let linkCaps = net.links.map(l => l.capacity);
        let minCap = Math.min(...linkCaps);
        let maxCap = Math.max(...linkCaps);
        let minWidth = netVisInteract.capVis.minWidth;
        let maxWidth = netVisInteract.capVis.maxWidth;
        let scale = 0.0;
        if (maxCap > minCap) {
            scale = (maxWidth - minWidth) / (maxCap - minCap);
        }
        netGroup.selectAll("line.netLink")
            .style("stroke-width", function (d) {
                return minWidth + (d.capacity - minCap) * scale;
            });
        netGroup.selectAll("line.netDemand")
            .style("stroke-width", function (d) {
                return minWidth + Math.max((d.demand - minCap), 0.0) * scale;
            });
    } else {
        let linkWidth = netVisInteract.linkWidth;
        let demandWidth = netVisInteract.demandWidth;
        netGroup.selectAll("line.netLink")
            .style("stroke-width", linkWidth);
        netGroup.selectAll("line.netDemand")
            .style("stroke-width", demandWidth);
    }
}

function vizDemands(svg, netVisInteract) {
    let netGroup = d3.select(svg).select("g");
    netGroup.selectAll("line.netDemand").classed('hidden', !netVisInteract.showDemands);
}


/**
 *  Highlights selected nodes. Observes the selected nodes array.
 *  @method nodeHighlighter
 */
function nodeHighlighter(svg, netVisInteract) {
    let selectedNodes = netVisInteract.selectedNodes;
    let netGroup = d3.select(svg).select("g");
    netGroup.selectAll("g.netNode").classed('highlight', function (d) {
        return (selectedNodes.indexOf(d.id) !== -1);
    });
}

/**
 *  Highlights selected links. Observes the selected links array.
 *  @method linkHighlighter
 */
function linkHighlighter(svg, netVisInteract) {
    var selectedLinks = netVisInteract.selectedLinks;
    let netGroup = d3.select(svg).select("g");
    netGroup.selectAll("line.netLink").classed('highlight', function (d) {
        return (selectedLinks.find(sl => sl[0] === d.source && sl[1] === d.target));
    });
}

/* Can't put logic that uses state information into dispactch functions
    so we'll put it in a separate function
 */
function genPanelClick(coords) {
    if (this.props.netVisInteract.mouseMode === 'edit') {
        this.props.nodeAddClick(coords);
    } else {
        this.props.panelClick(coords);
    }
}

/* Understands the different conditions and actions to be taken for node
   clicks, i.e., whether we are in "edit" or "view" or some other future mode
   of operation.
*/
function genNodeClick(node) {
    let selectedNodes = this.props.netVisInteract.selectedNodes;
    if (this.props.netVisInteract.mouseMode !== 'edit' || (selectedNodes.length < 1)) {
        this.props.nodeClick(node);
        return;
    }
    // check if node already selected
    if (selectedNodes.find((n) => n === node.id)) { // this will unselected it
        this.props.nodeClick(node);
        return;
    }
    if (selectedNodes.length === 1) {
        let nodes = this.props.net.nodes;
        let srcId = selectedNodes[0];
        let dstId = node.id;
        let srcNode = nodes.find(n => n.id === srcId);
        let dstNode = nodes.find(n => n.id === dstId);
        let links = this.props.net.links;
        if (links.find(l => l.source === srcId && l.target === dstId) ||
            links.find(l => l.source === dstId && l.target === srcId)) {
            alert(`Link ${srcId}-${dstId} is already in the network, Parallel links not currently supported.`);
            this.props.nodeClick(node);
            return;
        } else {
            let layer = srcNode.layer === dstNode.layer ? srcNode.layer : "adaptation";
            let linkInfo = {};
            linkInfo.source = srcId;
            linkInfo.target = dstId;
            linkInfo.layer = layer;
            this.props.linkAdd(linkInfo);
        }
    }
}

/* Understands the different conditions and actions to be taken for node
   double clicks, i.e., whether we are in "edit" or "view" or some other future mode
   of operation.
*/
function genNodeDblClick(node) {
    // console.log("in genNodeDblClick");
    if (this.props.netVisInteract.mouseMode !== 'edit') {
        this.props.nodeClick(node);
        return;
    }
    // Otherwise clear out all other selected nodes and links and send message
    // to bring up node edit dialog
    this.props.nodeEdit(node);
}

function genLinkDblClick(link) {
    if (this.props.netVisInteract.mouseMode == 'edit') {
        this.props.linkEdit(link);
    }
}

const mapStateToProps = (state) => {
    return {
        net: state.net,
        demands: state.demands,
        netAction: state.netAction,
        netVisInteract: state.netVisInteract,
        data: []
    };
}

const mapDispatchToProps = (dispatch) => {
    return {
        nodeClick: (node) => {
            dispatch({type: 'NODE_CLICK', node: node});
        },
        linkClick: (link) => {
            dispatch({type: 'LINK_CLICK', link: link});
        },
        panelClick: (coords) => {
            dispatch({type: 'PANEL_CLICK', coords: coords});
        },
        nodeAddClick: (coords) => {
            dispatch({type: 'PRE_NET_NODE_ADD', coords: coords});
        },
        linkAdd: (linkInfo) => {
            dispatch({type: 'PRE_NET_LINK_ADD', linkInfo: linkInfo});
        },

        nodeEdit: (node) => {
            dispatch({type: 'PRE_NODE_EDIT', node: node});
        },

        linkEdit: (link) => {
            dispatch({type: 'PRE_LINK_EDIT', link: link});
        }

    };
};

export const NetDrawContainer = connect(
    mapStateToProps,
    mapDispatchToProps)(NetDraw)



// WEBPACK FOOTER //
// ./src/netDraw/NetDraw.js